<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="h2">Preface</a></h2><a id="h2">
<p class="noindent"><span class="dropcap">T</span>hese twenty essays look at how our ancestors shaped the South Yorkshire countryside over the centuries. They deal not only with castles, country houses, churches and monasteries, but also with the houses and barns of peasant farmers, navigable rivers and industrial buildings, intriguing place-names such as Lindrick, and with fields, woods and moorland. Together, they tell the story of how the human landscape was created.</p>
<p class="indent">The book draws upon studies that I have made over the last fifty years. Some of my photographs were taken in the late 1960s and 1970s and are now historic documents in their own right. Parts of the text are based on articles that have appeared over the years in journals that are not readily accessible beyond specialist libraries. Occasionally, these articles were written with joint authors. I particularly wish to acknowledge the contributions and warm friendship of John Rodwell, formerly Professor of Plant Ecology at Lancaster University, who wrote two articles with me in the journal, <em class="italic">Landscapes</em>, the first on his native township of Wombwell and the second on the King’s Wood in Lindrick. The publications of other friends, many of whom have accompanied me on visits to South Yorkshire’s numerous historic sites over the years, are acknowledged in the footnotes.</p>
<p class="indent">This book, then, is about ‘history on the ground’. Documentary research in the archives is an integral part of any historical study, but local and family historians combine the written evidence with what they see all around them, and they welcome the contributions of other specialists, including archaeologists, architects, botanists, geographers, place-name scholars, and aerial photographers.</p>
<p class="indent">I would particularly like to thank an old friend, Brian Elliott, for doing the editorial work and Matt Jones at Pen &amp; Sword for overseeing the production process.</p>
<p class="right">David Hey<br/>July 2014</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_preface.vue?2a04d018